__turbopack_context__.v({
  "emptyStateWrapper": "emptyState-module-scss-module__ZARbXq__emptyStateWrapper",
  "headline": "emptyState-module-scss-module__ZARbXq__headline",
  "subhead": "emptyState-module-scss-module__ZARbXq__subhead",
});
